import { boolean, date, InferType, number, object, ObjectSchema, string, mixed, array } from "yup";
import { CriarObraContract } from "../contracts/criar-obra.contract";
import { ModalityEnum } from "../../../shared/utils/enum/enum";
import { UnitOfMeasureEnum } from "../../../shared/components/formulario/select/SelectUnitOfMeasure";

export const criarObraSchema: ObjectSchema<CriarObraContract> = object({
    workName: string().required("Nome da obra é obrigatório"),
    idClient: string().required("Cliente é obrigatório"),
    startDate: date().required("Data de início é obrigatória"),
    endDate: date().required("Data de término é obrigatória"),
    totalValue: number()
        .typeError("Valor total deve ser um número")
        .transform((value, originalValue) => {
            if (typeof originalValue === "string") {
                // Remove tudo que não for dígito ou vírgula
                let cleaned = originalValue.replace(/[^\d,]/g, "");
                // Troca a última vírgula por ponto (caso exista)
                const lastComma = cleaned.lastIndexOf(",");
                if (lastComma !== -1) {
                    cleaned =
                        cleaned.slice(0, lastComma).replace(/,/g, "") +
                        "." +
                        cleaned.slice(lastComma + 1);
                }
                if (!cleaned) return undefined;
                const valorNumber = Number(cleaned);
                return isNaN(valorNumber) ? undefined : valorNumber;
            }
            return value;
        })
        .required("Valor total é obrigatório"),
    description: string().nullable().default(null),
    address: object().shape({
        zipCode: string().required("CEP é obrigatório"),
        street: string().required("Rua é obrigatória"),
        number: string().required("Número é obrigatório"),
        neighborhood: string().required("Bairro é obrigatório"),
        city: string().required("Cidade é obrigatória"),
        state: string().required("Estado é obrigatório"),
        complement: string().default(""),
    }),
    contractFile: mixed<File>()
        .required("É obrigatório informar um arquivo")
        .test("fileRequired", "É obrigatório informar um arquivo", value => !!value),
    workStages: array()
        .of(
            object().shape({
                name: string().required("Nome da etapa é obrigatório"),
                description: string().nullable(),
                startDate: date().required("Data de início da etapa é obrigatória"),
                endDate: date().required("Data de término da etapa é obrigatória"),
                order: number().nullable(),
            })
        )
        .min(1, "É obrigatório informar ao menos uma etapa")
        .required("Etapas são obrigatórias")
        .default([]),
    positionsDto: array()
        .of(
            object().shape({
                name: string().required("Nome do cargo é obrigatório"),
                description: string().required("Descrição do cargo é obrigatória"),
                active: boolean().required(),
                priceDto: array()
                    .of(
                        object().shape({
                            value: number().required("Valor é obrigatório").transform((value, originalValue) => {
                                if (typeof originalValue === "string") {
                                    const cleaned = originalValue.replace(/\./g, "").replace(",", ".").replace(/[^0-9.]/g, "");
                                    if (!cleaned) return undefined;
                                    const valorNumber = Number(cleaned);
                                    return isNaN(valorNumber) ? undefined : valorNumber;
                                }
                                return value;
                            }),
                            modality: mixed<UnitOfMeasureEnum>()
                                .oneOf(Object.values(UnitOfMeasureEnum), "Modalidade inválida")
                                .required("Modalidade é obrigatória"),
                            active: boolean().required(),
                        })
                    )
                    .required("É obrigatório informar ao menos um preço")
                    .min(1, "É obrigatório informar ao menos um preço"),
            })
        )
        .default([]),
});

export type CriarObraFormData = InferType<typeof criarObraSchema>;